import { render, staticRenderFns } from "./gate.vue?vue&type=template&id=2c40b14f&scoped=true&"
import script from "./gate.vue?vue&type=script&lang=js&"
export * from "./gate.vue?vue&type=script&lang=js&"
import style0 from "./gate.vue?vue&type=style&index=0&id=2c40b14f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40b14f",
  null
  
)

export default component.exports